import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {getAllReportTypes} from '../../fetch/reportApi';
import {CategoryToReportTypeType} from '../../types/CategoryToReportTypeType';
import {ReportTypes} from '../../types/enums/ReportTypes';
import {distinctArray} from '../../util/ArrayUtil';
import {AppDispatch} from '../../store';

export interface ReportTypeState {
    reportTypes: ReportTypes[];
    categoryToReportTypes: CategoryToReportTypeType[];
}

const initialState: ReportTypeState = {
    reportTypes: [],
    categoryToReportTypes: []
};

const reportTypeSlice = createSlice({
    name: 'reportType',
    initialState,
    reducers: {
        reportTypesSet: (state, action: PayloadAction<CategoryToReportTypeType[]>) => {
            state.categoryToReportTypes = action.payload;
            state.reportTypes = action.payload ? distinctArray(action.payload.map(categoryToReportType => categoryToReportType.reportType)) : [];
        }
    }
});

export const {reportTypesSet} = reportTypeSlice.actions;
export default reportTypeSlice.reducer;

export const loadReportTypes = () => (dispatch: AppDispatch) => {
    getAllReportTypes(dispatch).then((response) => {
        if (response.success) {
            dispatch(reportTypesSet(response.result));
        }
    });
};
